import React, { useState, useRef, useEffect } from "react";
import { Columns3, Check } from "lucide-react";

const ColumnVisibilityMenu = ({ columns, columnVisibility, onToggle, theme, isRTL, label = "Columns" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const isDark = theme === "dark";

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={label}
        style={{
          display: "flex", alignItems: "center", gap: 6, padding: "8px 12px", borderRadius: 10,
          border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)"}`,
          background: isDark ? "rgba(255,255,255,0.05)" : "#fff",
          color: isDark ? "#e2e8f0" : "#334155", fontSize: 12.5, fontWeight: 600, cursor: "pointer",
        }}
      >
        <Columns3 size={14} /> {label}
      </button>
      {open && (
        <div
          style={{
            position: "absolute", top: "calc(100% + 6px)", [isRTL ? "left" : "right"]: 0, zIndex: 60,
            minWidth: 200, maxHeight: 280, overflowY: "auto", padding: 8, borderRadius: 12,
            background: isDark ? "rgba(15,23,42,0.98)" : "#fff",
            border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)"}`,
            boxShadow: isDark ? "0 16px 40px rgba(0,0,0,0.5)" : "0 16px 40px rgba(0,0,0,0.12)",
          }}
        >
          {columns.map((col) => {
            const visible = columnVisibility[col.id] !== false;
            return (
              <button
                key={col.id}
                type="button"
                onClick={() => onToggle(col.id)}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%",
                  padding: "7px 8px", borderRadius: 8, border: "none", background: "transparent",
                  color: isDark ? "#e2e8f0" : "#334155", fontSize: 12.5, cursor: "pointer", textAlign: isRTL ? "right" : "left",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
              >
                <span>{col.label}</span>
                {visible && <Check size={14} color="#3b82f6" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ColumnVisibilityMenu;
